import a from "./internal/_curry2.mjs";
import h from "./internal/_isString.mjs";
var c = /* @__PURE__ */ a(function(n, r) {
  var t = n < 0 ? r.length + n : n;
  return h(r) ? r.charAt(t) : r[t];
});
export {
  c as default
};
